import React from 'react'
import { theme } from '../../styles/theme';
import './Tick.scss';

export default function Tick() {
    return <svg className='tick' viewBox='3 7 16 16'>
        <path fill={theme.colors.brand} d='M16.045 8.744l-.391-.391c-.133-.133-.294-.199-.483-.199s-.351.066-.483.199l-5.121 5.071-2.492-2.499c-.133-.133-.294-.199-.483-.199s-.359.059-.483.199l-.448.506c-.124.14-.199.294-.199.483s.066.351.199.483l2.457 2.572.966.966c.133.133.294.199.483.199s.351-.066.483-.199l.966-.966 5.028-5.259a.66.66 0 0 0 .199-.483c0-.189-.066-.351-.199-.483'/>
    </svg>;
}
